import { getBoundRefProvider } from '@wix/materializer'

export const getFeatureBoundRefProvider = (featureName: string) => getBoundRefProvider(['exports', featureName])
